import { IconType } from "react-icons";
import {
  FcPhoneAndroid,
  FcCellPhone,
  FcIdea,
  FcShipped,
  FcGlobe,
  FcHome,
  FcSafe,
  FcList,
  FcServices,
  FcWiFiLogo,
  FcAutomotive,
  FcPortraitMode,
  FcLike,
  FcDonate,
  FcConferenceCall,
  FcDisplay,
  FcPhone,
  FcMoneyTransfer,
  FcDepartment,
  FcBriefcase,
} from "react-icons/fc";

import {
  MdLiveTv,
  MdLocalCarWash,
  MdOutlinePropaneTank,
  MdCreditCard,
  MdAccountBalance,
  MdHomeWork,
  MdPayments,
  MdSchool,
  MdWaterDrop,
  MdElectricMeter,
  MdDirectionsTransit,
  MdReceipt,
  MdSubscriptions,
} from "react-icons/md";

export interface NavItem {
  id: string;
  label: string;
  path?: string;
  apiName?: string;
  icon?: IconType;
  themeColor?: string; // e.g. "orange", "red"
  visible?: boolean; // toggle visibility manually
  requiresAuth?: boolean; // true if login required
  children?: NavItem[]; // nested subcategories
  priority?: number;
  menupriority?: number;
}

export const navbarConfig: NavItem[] = [
  {
    id: "recharge_bills",
    label: "Recharge & Bills",
    icon: FcIdea,
    visible: true,
    requiresAuth: false,
    priority: 1,
    children: [
      {
        id: "mobile_postpaid",
        label: "Mobile Postpaid",
        path: "/mobile-postpaid",
        apiName: "Mobile Postpaid",
        icon: FcPhoneAndroid,
        visible: true,
        requiresAuth: false,
        priority: 1,
        menupriority: 1,
      },
      {
        id: "mobile_prepaid",
        label: "Mobile Prepaid",
        path: "/mobile-prepaid",
        apiName: "mobile prepaid",
        // apiName: "Mobile Prepaid",
        icon: FcCellPhone,
        visible: true,
        requiresAuth: false,
        priority: 1,
        menupriority: 1,
      },
      {
        id: "broadband_postpaid",
        label: "Broadband Postpaid",
        path: "/broadband-postpaid",
        apiName: "Broadband Postpaid",
        icon: FcWiFiLogo,
        visible: true,
        requiresAuth: false,
        priority: 3,
        menupriority: 3,
      },
      {
        id: "electricity",
        label: "Electricity Bill",
        path: "/electricity-bill",
        apiName: "Electricity",
        icon: FcIdea,
        visible: true,
        requiresAuth: false,
        priority: 2,
        menupriority: 2,
      },
      {
        id: "dth_recharge",
        label: "DTH Recharge",
        path: "/dth-recharge",
        apiName: "DTH",
        icon: MdLiveTv,
        themeColor: "orange",
        visible: true,
        requiresAuth: false,
        priority: 3,
        menupriority: 5,
      },
      {
        id: "book_cylinder",
        label: "Book a Cylinder",
        path: "/book-cylinder",
        apiName: "LPG Gas",
        icon: FcShipped,
        visible: true,
        requiresAuth: false,
        priority: 4,
        menupriority: 10,
      },
      {
        id: "pay_gas_bill",
        label: "Pay Gas Bill",
        path: "/pay-gas-bill",
        apiName: "Gas",
        icon: MdOutlinePropaneTank,
        themeColor: "red",
        visible: true,
        requiresAuth: false,
        priority: 4,
        menupriority: 10,
      },
      {
        id: "fastag",
        label: "Fastag",
        path: "/fastag-bill",
        apiName: "Fastag",
        icon: MdLocalCarWash,
        themeColor: "purple",
        visible: true,
        requiresAuth: false,
        priority: 6,
        menupriority: 6,
      },
      {
        id: "cable_tv",
        label: "Cable TV",
        path: "/cable-tv",
        apiName: "Cable TV",
        icon: FcDisplay,
        visible: true,
        requiresAuth: false,
        priority: 6,
        menupriority: 6,
      },
      {
        id: "metro_recharge",
        label: "Metro Recharge",
        path: "/metro-recharge",
        apiName: "Metro Recharge",
        icon: FcAutomotive,
        visible: true,
        requiresAuth: false,
        priority: 6,
        menupriority: 6,
      },
      {
        id: "landline_postpaid",
        label: "Landline Postpaid",
        path: "/landline-postpaid",
        apiName: "Landline Postpaid",
        icon: FcPhone,
        visible: true,
        requiresAuth: false,
        priority: 7,
        menupriority: 7,
      },
      {
        id: "prepaid_meter",
        label: "Prepaid Meter",
        path: "/prepaid-meter",
        apiName: "Prepaid Meter",
        icon: MdElectricMeter,
        themeColor: "orange",
        visible: true,
        requiresAuth: false,
        priority: 8,
        menupriority: 8,
      },
      {
        id: "ncmc_recharge",
        label: "NCMC Recharge",
        path: "/ncmc-recharge",
        apiName: "NCMC Recharge",
        icon: MdDirectionsTransit,
        themeColor: "blue",
        visible: true,
        requiresAuth: false,
        priority: 9,
        menupriority: 9,
      },
    ],
  },
  {
    id: "utility_services",
    label: "Utility Services",
    icon: FcGlobe,
    visible: true,
    requiresAuth: false,
    priority: 3,
    children: [
      {
        id: "insurance",
        label: "Insurance",
        path: "/insurance",
        apiName: "Insurance",
        icon: FcSafe,
        visible: true,
        requiresAuth: false,
        priority: 1,
      },
      {
        id: "health_insurance",
        label: "Health Insurance",
        path: "/health-insurance",
        apiName: "Health Insurance",
        icon: FcLike,
        visible: true,
        requiresAuth: false,
        priority: 2,
        menupriority: 8,
      },
      {
        id: "donation",
        label: "Donation",
        path: "/donation",
        apiName: "Donation",
        icon: FcDonate,
        visible: true,
        requiresAuth: false,
        priority: 2,
        menupriority: 8,
      },
      // {
      //   id: "forex",
      //   label: "Forex",
      //   path: "/forex",
      //   apiName: "Forex",
      //   icon: FcCurrencyExchange,
      //   visible: true,
      //   requiresAuth: false,
      //   priority: 3,
      // },
      // {
      //   id: "fx retail",
      //   label: "FX Retail",
      //   path: "/fx-retail",
      //   apiName: "FX Retail",
      //   icon: FcCurrencyExchange,
      //   visible: true,
      //   requiresAuth: false,
      //   priority: 4,
      //   menupriority: 7,
      // },
      {
        id: "life_insurance",
        label: "Life Insurance",
        path: "/life-insurance",
        apiName: "Life Insurance",
        icon: FcPortraitMode,
        visible: true,
        requiresAuth: false,
        priority: 4,
        menupriority: 7,
      },
      {
        id: "clubs_and_associations",
        label: "Clubs & Associations",
        path: "/clubs-and-associations",
        apiName: "Clubs And Associations",
        icon: FcConferenceCall,
        visible: true,
        requiresAuth: false,
        priority: 4,
        menupriority: 7,
      },
      {
        id: "housing_society",
        label: "Housing Society",
        path: "/housing-society",
        apiName: "Housing Society",
        icon: FcHome,
        visible: true,
        requiresAuth: false,
        priority: 4,
        menupriority: 7,
      },
      {
        id: "municipal_services",
        label: "Municipal Services",
        path: "/municipal-services",
        apiName: "Municipal Services",
        icon: FcDepartment,
        visible: true,
        requiresAuth: false,
        priority: 5,
        menupriority: 9,
      },
      {
        id: "subscription",
        label: "Subscription",
        path: "/subscription",
        apiName: "Subscription",
        icon: MdSubscriptions,
        themeColor: "red",
        visible: true,
        requiresAuth: false,
        priority: 5,
        menupriority: 9,
      },
    ],
  },
  {
    id: "payments_services",
    label: "Payments & Services",
    icon: FcServices,
    visible: true,
    requiresAuth: false,
    priority: 2,
    children: [
      {
        id: "credit_cards",
        label: "Credit Card",
        path: "/credit-card",
        // apiName: "Credit Card",
        apiName: "credit card",
        icon: MdCreditCard,
        themeColor: "cyan",
        visible: true,
        requiresAuth: false,
        menupriority: 3,
      },
      {
        id: "loan_Repayment",
        label: "Loan Repayment",
        path: "/loan-repayment",
        apiName: "Loan Repayment",
        icon: MdPayments,
        themeColor: "green",
        visible: true,
        requiresAuth: false,
        menupriority: 11,
      },
      {
        id: "Education_Fees",
        label: "Education Fees",
        path: "/Education-Fees",
        apiName: "Education Fees",
        icon: MdSchool,
        themeColor: "orange",
        visible: true,
        requiresAuth: false,
        menupriority: 12,
      },
      // {
      //   id: "hospital",
      //   label: "Hospital",
      //   path: "/hospital",
      //   apiName: "Hospital",
      //   icon: MdLocalHospital,
      //   themeColor: "red",
      //   visible: true,
      //   requiresAuth: false,
      //   menupriority: 13,
      // },
      {
        id: "municipal_taxes",
        label: "Municipal Taxes",
        path: "/municipal-taxes",
        apiName: "Municipal Taxes",
        icon: MdAccountBalance,
        themeColor: "blue",
        visible: true,
        requiresAuth: false,
        menupriority: 14,
      },
      {
        id: "rental",
        label: "Rental",
        path: "/rental",
        apiName: "Rental",
        icon: MdHomeWork,
        themeColor: "purple",
        visible: true,
        requiresAuth: false,
        menupriority: 15,
      },
      {
        id: "water",
        label: "Water",
        path: "/water",
        apiName: "Water",
        icon: MdWaterDrop,
        themeColor: "cyan",
        visible: true,
        requiresAuth: false,
        menupriority: 16,
      },
      {
        id: "e_challan",
        label: "E-Challan",
        path: "/e-challan",
        apiName: "E-Challan",
        icon: MdReceipt,
        themeColor: "grey",
        visible: true,
        requiresAuth: false,
        menupriority: 17,
      },
      {
        id: "recurring_deposit",
        label: "Recurring Deposit",
        path: "/recurring-deposit",
        apiName: "Recurring Deposit",
        icon: FcMoneyTransfer,
        visible: true,
        requiresAuth: false,
        menupriority: 18,
      },
      {
        id: "nps",
        label: "National Pension System",
        path: "/nps",
        apiName: "NPS",
        icon: FcBriefcase, // Using FcTimeline or FcBriefcase if imported
        visible: true,
        requiresAuth: false,
        menupriority: 19,
      },
    ],
  },
];

//helper functions
// ------------------------------------------------------
// Simulated Auth state (RTK / context se sync hoga)
// ------------------------------------------------------
let isLoggedIn = true;

export function setAuthState(loggedIn: boolean) {
  isLoggedIn = loggedIn;
}

// ------------------------------------------------------
// Sorting helpers (single source of truth)
// ------------------------------------------------------
export function compareByMenuPriority(a: NavItem, b: NavItem) {
  const ma = a.menupriority ?? Number.MAX_SAFE_INTEGER;
  const mb = b.menupriority ?? Number.MAX_SAFE_INTEGER;

  if (ma !== mb) return ma - mb;

  const pa = a.priority ?? 100;
  const pb = b.priority ?? 100;
  if (pa !== pb) return pa - pb;

  return String(a.label).localeCompare(String(b.label));
}

/** Backwards compatible: use same logic as compareByMenuPriority */
export function compareMenuItems(a: NavItem, b: NavItem) {
  return compareByMenuPriority(a, b);
}

// ------------------------------------------------------
// Flatten helpers
// ------------------------------------------------------
export function flattenNavItemsInSingleArray(
  items: NavItem[],
): (NavItem & { parentId?: string; parentIcon?: any })[] {
  return items.flatMap((cat) =>
    (cat.children || []).map((child) => ({
      ...child,
      parentId: cat.id,
      parentIcon: cat.icon,
    })),
  );
}

export function flattenNavItems(
  items: NavItem[],
): (NavItem & { parentId?: string; parentIcon?: any })[] {
  const result: (NavItem & { parentId?: string; parentIcon?: any })[] = [];

  for (const cat of items) {
    if (cat.children && cat.children.length > 0) {
      result.push(
        ...flattenNavItems(cat.children).map((child) => ({
          ...child,
          parentId: cat.id,
          parentIcon: cat.icon,
        })),
      );
    } else if (cat.path) {
      result.push({
        ...cat,
        parentId: undefined,
        parentIcon: undefined,
      });
    }
  }

  return result;
}

// ------------------------------------------------------
// Visible + auth filter
// ------------------------------------------------------
function visibleAuth(items: NavItem[]) {
  return items
    .filter((x) => x.visible !== false)
    .filter((x) => !x.requiresAuth || isLoggedIn);
}

export function getVisibleNavbar(items: NavItem[] = navbarConfig): NavItem[] {
  return visibleAuth(items).map((item) => ({
    ...item,
    children: item.children ? getVisibleNavbar(item.children) : undefined,
  }));
}

// ------------------------------------------------------
// Service menu utilities
// ------------------------------------------------------

// ALL children having menupriority (no limit)
export function getServiceMenuItemsAll(
  config: NavItem[] = navbarConfig,
): NavItem[] {
  const parents = visibleAuth(config).sort(
    (a, b) => (a.priority ?? 100) - (b.priority ?? 100),
  );

  const flat: NavItem[] = [];
  for (const p of parents) {
    const kids = visibleAuth(p.children ?? [])
      // .filter((c) => c.menupriority !== undefined)
      .sort(compareByMenuPriority);
    flat.push(...kids);
  }
  return flat;
}

function sortParents(a: NavItem, b: NavItem) {
  const pa = a.priority ?? 100;
  const pb = b.priority ?? 100;
  return pa - pb;
}

/**
 * Single row:
 * - collect children with `menupriority`
 * - keep parent order, each parent's children sorted
 * - if total > limit, rest goes under "More"
 */
export function getServiceMenuRow(limit = 8, moreLabel = "More"): NavItem[] {
  const parents = visibleAuth(navbarConfig).sort(sortParents);

  const flat: NavItem[] = [];
  for (const p of parents) {
    const kids = visibleAuth(p.children ?? [])
      // .filter((c) => c.menupriority !== undefined)
      .sort(compareByMenuPriority);
    flat.push(...kids);
  }

  if (flat.length <= limit) return flat;

  const head = flat.slice(0, limit);
  const tail = flat.slice(limit);

  return [
    ...head,
    {
      id: "__service_more",
      label: moreLabel,
      icon: FcList,
      visible: true,
      children: tail,
    },
  ];
}

// ------------------------------------------------------
// Find helpers
// ------------------------------------------------------
export function findMenuById(
  id: string,
  items: NavItem[] = navbarConfig,
): NavItem | null {
  for (const item of items) {
    if (item.id === id) return item;
    if (item.children) {
      const found = findMenuById(id, item.children);
      if (found) return found;
    }
  }
  return null;
}

export function findMenuByPath(
  path: string | undefined,
  items: NavItem[] = navbarConfig,
): NavItem | null {
  if (!path) return null;

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const cleanPath = normalizedPath.replace(/\/+$/, "").toLowerCase();

  for (const item of items) {
    if (item.path) {
      const itemPathClean = (
        item.path.startsWith("/") ? item.path : `/${item.path}`
      )
        .replace(/\/+$/, "")
        .toLowerCase();

      if (itemPathClean === cleanPath) {
        return item;
      }
    }
    if (item.children?.length) {
      const found = findMenuByPath(path, item.children);
      if (found) return found;
    }
  }

  return null;
}

//======================================================//
//======================================================//
// ---------------------- Sorting & flattening ------------------------
// export function compareMenuItems(a: NavItem, b: NavItem) {
//   // Case 1: both have menupriority → sort by menupriority
//   if (a.menupriority !== undefined && b.menupriority !== undefined) {
//     return a.menupriority - b.menupriority;
//   }
//   // Case 2: only one has menupriority → it comes first
//   if (a.menupriority !== undefined) return -1;
//   if (b.menupriority !== undefined) return 1;

//   // Case 3: fallback to priority
//   const pa = a.priority ?? 100;
//   const pb = b.priority ?? 100;
//   return pa - pb;
// }

// Flatten nav items to a single array
// export function flattenNavItemsInSingleArray(
//   items: NavItem[]
// ): (NavItem & { parentId?: string; parentIcon?: any })[] {
//   return items.flatMap((cat) =>
//     (cat.children || []).map((child) => ({
//       ...child,
//       parentId: cat.id,
//       parentIcon: cat.icon,
//     }))
//   );
// }
// Flatten nav items but only leaf nodes (with path)
// export function flattenNavItems(
//   items: NavItem[]
// ): (NavItem & { parentId?: string; parentIcon?: any })[] {
//   const result: (NavItem & { parentId?: string; parentIcon?: any })[] = [];

//   for (const cat of items) {
//     if (cat.children && cat.children.length > 0) {
//       // recurse into children
//       result.push(
//         ...flattenNavItems(cat.children).map((child) => ({
//           ...child,
//           parentId: cat.id,
//           parentIcon: cat.icon,
//         }))
//       );
//     } else if (cat.path) {
//       // only include leaf items
//       result.push({
//         ...cat,
//         parentId: undefined,
//         parentIcon: undefined,
//       });
//     }
//   }
//   return result;
// }

// Split children into main and more (top 10 by default)
export function splitMainMoreChildren(items: NavItem[], mainCount = 10) {
  const flat = flattenNavItems(items);
  const sorted = [...flat].sort(compareMenuItems);
  return {
    main: sorted.slice(0, mainCount),
    more: sorted.slice(mainCount),
  };
}

// ---------------------- Find helpers ------------------------
// export function findMenuById(
//   id: string,
//   items: NavItem[] = navbarConfig
// ): NavItem | null {
//   for (const item of items) {
//     if (item.id === id) return item;
//     if (item.children) {
//       const found = findMenuById(id, item.children);
//       if (found) return found;
//     }
//   }
//   return null;
// }

////////////////////////////////?
// export function findMenuByPath(
//   path: string | undefined,
//   items: NavItem[] = navbarConfig
// ): NavItem | null {
//   if (!path) return null;

//   const normalizedPath = path.startsWith("/") ? path : `/${path}`;
//   const cleanPath = normalizedPath.replace(/\/+$/, "");

//   for (const item of items) {
//     if (item.path) {
//       const itemPathClean = item.path.startsWith("/")
//         ? item.path.replace(/\/+$/, "")
//         : `/${item.path.replace(/\/+$/, "")}`;
//       if (itemPathClean.toLowerCase() === cleanPath.toLowerCase()) {
//         return item;
//       }
//     }
//     if (item.children && item.children.length > 0) {
//       const found = findMenuByPath(path, item.children);
//       if (found) return found;
//     }
//   }

//   return null;
// }

// ---------------------- Visibility helpers ------------------------
export function setItemVisibility(
  id: string,
  visible: boolean,
  items: NavItem[] = navbarConfig,
): boolean {
  for (const item of items) {
    if (item.id === id) {
      item.visible = visible;
      return true;
    }
    if (item.children && setItemVisibility(id, visible, item.children)) {
      return true;
    }
  }
  return false;
}

// ---------------------- Get visible navbar ------------------------
// Automatically filters by visible and requiresAuth
// export function getVisibleNavbar(items: NavItem[] = navbarConfig): NavItem[] {
//   return items
//     .filter((item) => item.visible !== false)
//     .filter((item) => !item.requiresAuth || isLoggedIn)
//     .map((item) => ({
//       ...item,
//       children: item.children ? getVisibleNavbar(item.children) : undefined,
//     }));
// }

// ---------------------- Hook for main/more ------------------------
export function useNav(mainCount = 10) {
  const visibleNav = getVisibleNavbar(navbarConfig);
  return splitMainMoreChildren(visibleNav, mainCount);
}

//////////////////////////////////////////////////////////////////////

/** sort strictly by menupriority; if tie, fallback to priority; last fallback: label */
// export function compareByMenuPriority(a: NavItem, b: NavItem) {
//   const ma = a.menupriority;
//   const mb = b.menupriority;

//   if (ma !== undefined && mb !== undefined) {
//     if (ma !== mb) return ma - mb;
//     // tie-breakers
//     const pa = a.priority ?? 100;
//     const pb = b.priority ?? 100;
//     if (pa !== pb) return pa - pb;
//     return String(a.label).localeCompare(String(b.label));
//   }
//   // only items with menupriority should be considered in this flow,
//   // but keep a deterministic order if something slips through:
//   if (ma !== undefined) return -1;
//   if (mb !== undefined) return 1;
//   return 0;
// }

/**
 * For each parent, keep only children that have menupriority,
 * sort by menupriority, and if >limit, push a "More" item at index = limit (i.e., 9th).
 * If no child has menupriority, parent ends up with empty children.
 */

// ab "service menu" ke liye nav[] me tumhare top-level categories ayenge,
// aur unke children already filtered+sorted+More ke saath ready honge.
///--------------------------------------------------------

// let isLoggedIn = true; // wire from Redux if needed
// export function setAuthState(v: boolean) { isLoggedIn = v; }

// function visibleAuth(items: NavItem[]) {
//   return items
//     .filter(x => x.visible !== false)
//     .filter(x => !x.requiresAuth || isLoggedIn);
// }

/** return ALL children that have menupriority, parent order respected, child order by menupriority */
// export function getServiceMenuItemsAll(config: NavItem[] = navbarConfig): NavItem[] {
//   const parents = visibleAuth(config).sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100));

//   const flat: NavItem[] = [];
//   for (const p of parents) {
//     const kids = visibleAuth(p.children ?? [])
//       .filter(c => c.menupriority !== undefined)
//       .sort((a, b) => {
//         const ma = a.menupriority!; const mb = b.menupriority!;
//         if (ma !== mb) return ma - mb;
//         const pa = a.priority ?? 100; const pb = b.priority ?? 100;
//         if (pa !== pb) return pa - pb;
//         return String(a.label).localeCompare(String(b.label));
//       });
//     flat.push(...kids);
//   }
//   return flat; // no limit, no “More”
// }

// parent order: priority asc; then stable
// function sortParents(a: NavItem, b: NavItem) {
//   const pa = a.priority ?? 100;
//   const pb = b.priority ?? 100;
//   if (pa !== pb) return pa - pb;
//   return 0;
// }

// child order: menupriority asc; then priority; then label
// function sortByMenuPriority(a: NavItem, b: NavItem) {
//   const ma = a.menupriority ?? Number.MAX_SAFE_INTEGER;
//   const mb = b.menupriority ?? Number.MAX_SAFE_INTEGER;
//   if (ma !== mb) return ma - mb;

//   const pa = a.priority ?? 100;
//   const pb = b.priority ?? 100;
//   if (pa !== pb) return pa - pb;

//   return String(a.label).localeCompare(String(b.label));
// }

/**
 * Build a single row:
 * - Collect ONLY children with `menupriority` from all top-level parents
 * - Keep parent order, sort each parent's children by `menupriority`
 * - If total > limit, place a synthetic "More" item at index = limit
 *   and push the overflow into its `children`.
 */
// export function getServiceMenuRow(
//   limit = 8,
//   moreLabel = "More"
// ): NavItem[] {
//   const parents = visibleAuth(navbarConfig).sort(sortParents);

//   const flat: NavItem[] = [];
//   for (const p of parents) {
//     const kids = visibleAuth(p.children ?? [])
//       .filter(c => c.menupriority !== undefined)
//       .sort(sortByMenuPriority);

//     flat.push(...kids);
//   }

//   if (flat.length <= limit) return flat;

//   const head = flat.slice(0, limit);
//   const tail = flat.slice(limit);

//   const moreNode: NavItem = {
//     id: "__service_more",
//     label: moreLabel,
//     icon: FiMoreHorizontal,
//     visible: true,
//     children: tail,
//   };
//   return [...head, moreNode];
// }
